/**
 * @file: TypewriterText.tsx
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

import { Typography } from '@euler/app/components/typography';
import { memo } from 'react';
import { Text } from 'react-native';

/**
 * Text typed out up to `typed` characters (from `useTypewriter`). The whole
 * text is laid out from the first frame and the untyped rest is drawn
 * transparent, so its lines and height never change while it types.
 */
export const TypewriterText = memo(
  ({
    text,
    typed,
    ...props
  }: Typography.TextBaseProps & { text: string; typed: number }) => {
    const chars = Array.from(text);
    return (
      <Typography.Text accessibilityLabel={text} {...props}>
        {chars.slice(0, typed).join('')}
        <Text style={{ color: 'transparent' }}>
          {chars.slice(typed).join('')}
        </Text>
      </Typography.Text>
    );
  },
);
